import React from "react"
import { Plane, Bus, Building2, Globe, X, Plus } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { cn } from "../../../../lib"

const TYPE_ICONS = {
  airport: Plane,
  bus: Bus,
  hotel: Building2,
  state: Globe,
}

const SearchSuggestionsRow = ({ item, onSelect }) => {
  const Icon = TYPE_ICONS[item.type] ?? Globe
  const subtitle = [item.city, item.country].filter(Boolean).join(", ")

  return (
    <button
      className={cn(
        "w-full flex items-center gap-1 justify-between p-1 rounded-xl transition ml-1 relative",
        "hover:bg-gray-50",
        item.is_selected && "bg-gray-50"
      )}
      onClick={() => onSelect?.(item)}
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <Icon className="w-4 h-4 text-app-content-subtle flex-shrink-0" />

        <div className="text-left flex-1 min-w-0">
          <div className="font-medium text-app-content flex items-center gap-1">
            <span className="text-[13px] flex-shrink-0">{item.name}</span>
            {item.city && item.city !== item.name && (
              <span className="text-app-content-subtle font-normal text-[11px] flex items-center min-w-0">
                (<span className="truncate capitalize max-w-[180px]">{item.city}</span>)
              </span>
            )}
          </div>
          {subtitle && <div className="text-xs text-app-content-subtle truncate">{subtitle}</div>}
        </div>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        {item.iata && (
          <motion.span
            className="px-1 py-1 w-9 rounded text-xs font-medium text-bg-muted bg-bg-muted/20 text-center"
            animate={{}}
            transition={{ duration: 0.3 }}
          >
            {item.iata}
          </motion.span>
        )}

        <AnimatePresence mode="wait">
          {item.is_selected ? (
            <motion.div
              key="selected"
              className="w-6 h-6 rounded flex items-center justify-center bg-transparent border-[0.5px] border-black"
              initial={{ scale: 0 }}
              animate={{ scale: 1.2 }}
              exit={{ scale: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <X className="w-3 h-3 text-black" />
            </motion.div>
          ) : (
            <motion.div
              key="unselected"
              className="w-6 h-6 rounded flex items-center justify-center bg-app-base-strong"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <Plus className="w-4 h-4 text-white" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </button>
  )
}

export default SearchSuggestionsRow
